import { TableCommissions } from "./components/table/TableCommissions";

export const PageCommissions = () => {
  return <TableCommissions />;
};
